var React = require('react');

function Archive (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M57.6,3.9H6.4c-2.9,0-5.2,2.3-5.2,5.2v6.3c0,2.9,2.3,5.2,5.2,5.2h0.1v34.3c0,2.9,2.3,5.2,5.2,5.2h40.6 c2.9,0,5.2-2.3,5.2-5.2V20.6h0.1c2.9,0,5.2-2.3,5.2-5.2V9.1C62.8,6.2,60.4,3.9,57.6,3.9z M54,54.9c0,0.9-0.8,1.7-1.7,1.7H11.7 c-0.9,0-1.7-0.8-1.7-1.7V20.6h44V54.9z M59.3,15.4c0,0.9-0.8,1.7-1.7,1.7H6.4c-0.9,0-1.7-0.8-1.7-1.7V9.1c0-0.9,0.8-1.7,1.7-1.7 h51.1c0.9,0,1.7,0.8,1.7,1.7V15.4z","key":0}),React.createElement("path",{"d":"M23.5,44.3h17.1c2.1,0,3.8-1.7,3.8-3.8V34c0-2.1-1.7-3.8-3.8-3.8H23.5c-2.1,0-3.8,1.7-3.8,3.8v6.5 C19.7,42.6,21.4,44.3,23.5,44.3z M23.2,34c0-0.1,0.1-0.3,0.3-0.3h17.1c0.1,0,0.3,0.1,0.3,0.3v6.5c0,0.1-0.1,0.3-0.3,0.3H23.5 c-0.1,0-0.3-0.1-0.3-0.3V34z","key":1})]);
}

Archive.defaultProps = {"version":"1.1","viewBox":"0 0 64 64","x":"0","y":"0","xmlSpace":"preserve"};

module.exports = Archive;

Archive.default = Archive;
